'use strict';

import { Entity } from '../Entity';

export class IndPolicyAccVal extends Entity {
  protected valueId;

  protected policy;

  protected anniversaryDate;

  protected accumulationValue;

  protected withdrawals;

  protected deposits;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.valueId = data.valueId;

    this.policy = data.policy;

    this.accumulationValue = data.accumulationValue;

    this.withdrawals = data.withdrawals;

    this.deposits = data.deposits;

    if (data.anniversaryDate) {
      const anniversaryDate = data.anniversaryDate.date.split(' ')[0].split('-');
      this.anniversaryDate =
        anniversaryDate[1] + '/' + anniversaryDate[2] + '/' + anniversaryDate[0];
    }
  }

  public getValueId() {
    return this.valueId;
  }

  public setValueId(valueId) {
    this.valueId = valueId;

    return this;
  }

  public getPolicy() {
    return this.policy;
  }

  public setPolicy(policy) {
    this.policy = policy;

    return this;
  }

  public getAnniversaryDate() {
    return this.anniversaryDate;
  }

  public setAnniversaryDate(anniversaryDate) {
    this.anniversaryDate = anniversaryDate;

    return this;
  }

  public getAccumulationValue() {
    return this.accumulationValue;
  }

  public setAccumulationValue(accumulationValue) {
    this.accumulationValue = accumulationValue;

    return this;
  }

  public getWithdrawals() {
    return this.withdrawals;
  }

  public setWithdrawals(withdrawals) {
    this.withdrawals = withdrawals;

    return this;
  }

  public getDeposits() {
    return this.deposits;
  }

  public setDeposits(deposits) {
    this.deposits = deposits;

    return this;
  }
}
